/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockStopwatchIcon24Solid = forwardRef('TimeClockStopwatchIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 2v1.552c-4.777.5-8.5 4.539-8.5 9.448a9.5 9.5 0 0 0 19 0 9.46 9.46 0 0 0-2.113-5.973l1.82-1.82a1 1 0 0 0-1.414-1.414l-1.82 1.82A9.456 9.456 0 0 0 13 3.551V2h2a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2h2Zm1 4.75a1 1 0 0 1 1 1V13a1 1 0 1 1-2 0V7.75a1 1 0 0 1 1-1Z" })));
});
